import React, {Component} from "react";
import {graphql} from "react-apollo";
import {fromJS, List} from "immutable";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {GET_PURCHASE_ORDER, ON_PURCHASE_ORDER_UPDATED} from "../../../queries/purchaseOrders";
import WarningBanner from "../../../components/WarningBanner";
import {WarehousePlace, PartnerPlace, TransportPlace} from "../../shared/Places";
// Shares the transfer details' layout.
import "../../stockTransfers/views/StockTransferDetails.scss";

class PurchaseOrderDetails extends Component {

  componentDidMount() {
    const {data} = this.props;
    this.unsubscribe = data.subscribeToMore({
      document: ON_PURCHASE_ORDER_UPDATED,
      updateQuery: (prev) => {
        data.refetch();
        return prev;
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  render() {
    const {loading, error, purchaseOrder} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    if (!purchaseOrder) return <p>Purchase order not found</p>

    const order = fromJS(purchaseOrder);
    const status = order.get("status");

    return (
      <div className="StockTransferDetails PurchaseOrderDetails">
        <WarningBanner show={!!order.get("notes")} error={false} message={`Note: ${order.get("notes")}`} />
        <div className="overview section">
          <PartnerPlace title="Ship from" partnerId={order.get("partnerId")} name={order.get("partnerName")} />
          <WarehousePlace title="Ship to" warehouseId={order.get("destinationWarehouseId")} />
          <TransportPlace
            transportType={order.get("transportType")}
            carrierReference={order.get("carrierReference")}
            expectedDate={order.get("expectedDeliveryDate")}
            expectedLabel={status === "received" ? "Was expected" : "Expected"} />
        </div>
        <div className="section">
          <h4>Lines</h4>
          {this.renderLines(order.get("lines", List()), status === "received")}
        </div>
      </div>
    )
  }

  renderLines(lines, isReceived) {
    if (lines.size === 0) return <p className="empty">No lines yet. Use Edit Lines to add what you are ordering.</p>
    return (
      <table className="linesTable">
        <thead>
          <tr><th>SKU</th><th>Product</th><th>Ordered</th>{isReceived && <th>Received</th>}</tr>
        </thead>
        <tbody>
          {lines.map((line) => (
            <tr key={line.get("sku")}>
              <td>{line.get("sku")}</td>
              <td>{line.get("productTitle")}</td>
              <td>{line.get("quantity")}</td>
              {isReceived && <td>{line.get("receivedQuantity")}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}

const withQuery = graphql(GET_PURCHASE_ORDER, {
  options: (props) => ({fetchPolicy: "network-only", variables: {id: props.purchaseOrderId}}),
  skip: (props) => !props.purchaseOrderId,
});

export default withQuery(PurchaseOrderDetails);
